export default __webpack_public_path__ + "static/media/MAW.0770175f.svg";